import { Component } from '@angular/core';
import { FileType } from '../../../../../state-management/model/enums/state.enums';
import { EditableImageComponent } from '../../../../base/image/editable-image/editable-image.component';
import { CoordinatesSystem, ImageFormat, NoBreakpoints } from '../../../../../state-management/model/enums/screen-size.enums';
import { ImageCoordinates } from '../../../../../state-management/model/interfaces/screen-size.model';


@Component({
    selector: 'app-website-config-form-app-management',
    standalone: true,
    imports: [
        EditableImageComponent
    ],
    templateUrl: './website-config-form-app-management.component.html',
    styleUrl: './website-config-form-app-management.component.scss'
})
export class WebsiteConfigFormAppManagementComponent {

  public supportedFileTypes = [FileType.WEBP, FileType.PNG];
  public imageReference: ImageCoordinates = {
      coordinatesSystem: CoordinatesSystem.NoCoordinates,
      formatMap: {
        [NoBreakpoints.Unset]: ImageFormat.OneToOne,  
      }
    };
}
